import type { HTMLAttributes } from 'react';

export type StatusPillTone =
  'success' | 'neutral' | 'danger' | 'info' | 'warning';

const STATUS_PILL_TONE_CLASSES: Record<StatusPillTone, string> = {
  success: 'bg-green-50 text-green-700 border border-green-200',
  neutral: 'bg-gray-100 text-gray-600 border border-gray-300',
  danger: 'bg-red-50 text-red-700 border border-red-200',
  info: 'bg-indigo-50 text-indigo-700 border border-indigo-200',
  warning: 'bg-amber-50 text-amber-700 border border-amber-200',
};

const BASE_CLASSES =
  'inline-flex items-center whitespace-nowrap rounded-full px-2 py-px text-xs font-medium';

export interface StatusPillProps extends HTMLAttributes<HTMLSpanElement> {
  tone: StatusPillTone;
}

export function StatusPill({
  tone,
  className,
  children,
  ...rest
}: StatusPillProps) {
  const classes = [BASE_CLASSES, STATUS_PILL_TONE_CLASSES[tone], className]
    .filter(Boolean)
    .join(' ');
  return (
    <span {...rest} className={classes}>
      {children}
    </span>
  );
}
